import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
  BooleanField,
} from "@pankod/refine-antd";
import { IServiceAccount } from "interfaces";

export const ServiceAccountList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<IServiceAccount>({
    initialSorter: [
      {
        field: "service_account_id",
        order: "desc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="service_account_id">
        <Table.Column
          dataIndex="service_account_id"
          key="service_account_id"
          title="ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("service_account_id", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="name"
          key="name"
          title={t("serviceAccount.fields.name")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="client_id"
          key="client_id"
          title={t("serviceAccount.fields.client_id")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="is_active"
          key="is_active"
          title={t("serviceAccount.fields.is_active")}
          render={(value) => <BooleanField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title={t("parameter.fields.created_at")}
          render={(value) => <DateField value={value} format="LLL" />}
        />
        <Table.Column<IServiceAccount>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.service_account_id} />
              <ShowButton hideText size="small" recordItemId={record.service_account_id} />
              <DeleteButton hideText size="small" recordItemId={record.service_account_id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
